import axios from 'axios'
import React, { useState } from 'react'
import swal from "sweetalert";

const DeleteUser = () => {
    const [ toggle , setToggle ] = useState(false)

    const [ user , setUser ] = useState({
        email:"",
        password:"",
    })

    const [ verifyotp , setVerifyOtp ] = useState({
        user_id:'',
        reason:'',
        otp:""
    })

    const verifyChange =  e => {
        const { name , value } = e.target
        setVerifyOtp({...verifyotp,[name]: value})
    }


    const onhandleChange = (e) =>{
        const { name , value } = e.target
        setUser({...user,[name]: value})
    }

    const onSubmit = (e) =>{
        e.preventDefault()

        if(user?.email===''){
            swal({
              title: 'Error!',
              text: "Please Add Email!",
              icon: "warning",
              button: "Ok",
            });
            return false
        }else if(user.password===''){
            swal({
              title: 'Error!',
              text: "Password not be empty!",
              icon: "warning",
              button: "Ok",
            });
            return false
          }

        var data = {
            email:user?.email,
            password:user?.password,
        }

        console.log("data",data);

        axios.post(`https://alumni.infoware.xyz/api/auth/delete-user-generate-otp`, data,{})
        .then(res=>{
            if(res.data.success){
                console.log("RESPONSE", res?.data);
                swal({
                    // title: ,
                    text: "Your Otp will Sent in your Mail.",
                    icon: "success",
                    // button: "Cancel",
                });
                setToggle(true)
                setVerifyOtp({...verifyotp ,user_id:res?.data?.data?.user?.id})
            }
         }).catch(err=>{
             console.log(err.response.data);
             
             swal({
                title: err.response.data.message,
                text: "email or password is wrong!",
                icon: "error",
                button: "Cancel",
              });
              
         })
    }

    const onSubmitOtp = e => {
        e.preventDefault()
        if(verifyotp?.reason===''){
            swal({
              title: 'Error!',
              text: "Please Add reason!",
              icon: "warning",
              button: "Ok",
            });
            return false
        }else if(verifyotp.otp===''){
            swal({
              title: 'Error!',
              text: "Please add otp!",
              icon: "warning",
              button: "Ok",
            });
            return false
          }

        var data2 = {
            user_id:verifyotp?.user_id,
            reason: verifyotp?.reason,
            otp: parseInt(verifyotp?.otp)
        }
        console.log("vvv",data2);

        axios.post(`https://alumni.infoware.xyz/api/auth/delete-user-verify-otp`, data2,{})
        .then(res=>{
            if(res.data.success){
                console.log("RESPONSE", res?.data);
                swal({
                    // title: ,
                    text: "Request has been sent we will update you soon.",
                    icon: "success",
                    // button: "Cancel",
                });
                setToggle(false)
                setUser({email:"", password:""})
            }
         }).catch(err=>{
             console.log(err.response.data);
             
             swal({
                text: err.response.data.message,
                icon: "error",
                button: "Cancel",
              });
              
         })
    }

    console.log("verifyotp",verifyotp);

  return (
    <div className="signup_form">
    <div className="container">
      <div className="signup_wrapper">
        <div className="logo">
          <h2>#. {!toggle?"Delete an Account":"Verify Token"}</h2>
        </div>
          <>
            {/* <h3>Delete an Account</h3> */}
            {/* <p>One last step before starting your free trial.</p> */}
            {!toggle? 
            <div className="form_two">
              <div className="input_field_two">
                  <label htmlFor="1">Email *</label>
                  <input type="email" name="email" id="1" placeholder="Enter email id here" value={user?.email} onChange={onhandleChange} />
              </div>
              <div className="input_field_two">
                  <label htmlFor="">Password</label>
                  <input type="password" name="password" id="" placeholder="Enter password here"  value={user?.password} onChange={onhandleChange}/>
              </div>
              <div className="input_button">
                  <button onClick={onSubmit}>Delete Account</button>
              </div>
            </div>
            :
            <div className="form_two">
              <div className="input_field_two">
                  <label htmlFor="3">Reason *</label>
                  <input type="text" name="reason" id="3" placeholder="Enter Reason here" value={verifyotp?.reason} onChange={verifyChange} />
              </div>
              <div className="input_field_two">
                  <label htmlFor="">OTP</label>
                  <input type="number" name="otp" id="" placeholder="Enter Otp here"  value={verifyotp?.otp} onChange={verifyChange}/>
              </div>
              <div className="input_button">
                  <button onClick={onSubmitOtp}>Verify Otp</button>
              </div>
            </div>
            }
            <p className="privacy_policy">
              By proceeding, you agree to the <a href="http://" target="_blank" rel="noopener noreferrer">Terms and Conditions</a> and <a href="http://" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
            </p>
          </>
      </div>
    </div>
  </div>
  )
}

export default DeleteUser